import React from "react";
import { siteData } from "../data/mock";
import { BrainCircuit, Workflow, GraduationCap, Briefcase, BarChart3, Target } from "lucide-react";

const iconMap = { BrainCircuit, Workflow, GraduationCap, Briefcase, BarChart3, Target };

const Agenda = () => {
  const { agenda } = siteData;
  return (
    <section id="learn" className="py-16 sm:py-20 lg:py-32 relative">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="text-center max-w-[820px] mx-auto">
          <div className="flex items-center justify-center gap-3">
            <span className="eyebrow-line" />
            <span className="text-[11px] tracking-[0.32em] uppercase text-[#5EC7F5]">
              {agenda.eyebrow}
            </span>
            <span className="eyebrow-line" />
          </div>
          <h2 className="font-display text-[32px] sm:text-[44px] md:text-[52px] lg:text-[60px] leading-[1.02] sm:leading-[0.98] mt-6">
            <span className="text-gradient-title">{agenda.title}</span>{" "}
            <span className="font-italic-serif text-gradient-blue">
              {agenda.italic}
            </span>
          </h2>
          <p className="text-slate-400 text-[14px] sm:text-[15px] mt-6 max-w-[560px] mx-auto">
            {agenda.intro}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mt-12 sm:mt-14">
          {agenda.items.map((item) => {
            const Icon = iconMap[item.icon] || BrainCircuit;
            return (
              <div
                key={item.number}
                className="card-glow rounded-2xl p-6 sm:p-7 relative overflow-hidden group hover:border-[#5EC7F5]/25 transition-all duration-300"
              >
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl chip-blue flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#5EC7F5]" />
                  </div>
                  <span className="big-number-outline text-[72px] sm:text-[92px] leading-none absolute right-4 top-2 opacity-70 group-hover:opacity-100 transition-opacity">
                    {item.number}
                  </span>
                </div>
                <div className="mt-12 sm:mt-14 text-[10px] tracking-[0.28em] sm:tracking-[0.32em] uppercase text-slate-500">
                  {item.number}
                </div>
                <h3 className="font-display text-[20px] sm:text-[22px] leading-tight mt-2 text-white">
                  {item.title}
                </h3>
                <p className="text-slate-400 text-[13.5px] sm:text-[14px] leading-relaxed mt-4">
                  {item.desc}
                </p>
              </div>
            );
          })}

          {/* Certificate program teaser card */}
          <div className="rounded-2xl p-6 sm:p-7 relative overflow-hidden flex flex-col justify-between border border-[#5EC7F5]/30 bg-gradient-to-br from-[#0a2540]/70 to-[#0a1626]/70">
            <div>
              <div className="inline-flex items-center gap-2 chip-blue px-3 py-1 rounded-full">
                <span className="text-[10px] tracking-[0.28em] uppercase">
                  Bonus
                </span>
              </div>
              <h3 className="font-display text-[22px] sm:text-[26px] leading-tight mt-6 text-white">
                Get exclusive insights into our
              </h3>
              <p className="font-italic-serif text-[24px] sm:text-[28px] text-gradient-blue leading-none mt-1">
                AI & ML Certificate Program.
              </p>
              <p className="text-slate-400 text-[13.5px] sm:text-[14px] leading-relaxed mt-4">
                {agenda.footerNote}
              </p>
            </div>
            <a
              href="#register"
              className="mt-8 inline-flex items-center justify-center gap-2 py-3 rounded-full bg-[#5EC7F5] text-[#062026] font-semibold text-sm glow-blue-btn hover:bg-[#8ad8f7] transition-colors"
            >
              Reserve My Seat
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Agenda;
